import { makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  view: {
    display: "flex",
    height: "-webkit-fill-available",
    width: "100%",
    background: "rgb(236, 235, 239)",
    overflowY: "auto",
    overflowX: "auto",
  },

  container: {
    width: "100%",
    background: "rgb(236, 235, 239)",
    alignContent: "flex-start",
  },
  headerStyle: {
    fontWeight: "bold",
    color: theme.palette.primary.light,
    marginBottom: "5px",
  },
  header: {
    padding: "15px",
    marginBottom: "15px",
    marginLeft: "15px",
    marginTop: "15px",
  },
  rightCard: {
    marginBottom: "15px",
    marginLeft: "15px",
    paddingLeft: "20px",
    borderLeft: "1px solid #d5d2d5",
  },

  submitButton: {
    width: "100%",
  },
  title: {
    height: "60px",
    color: "#29132e",
    backgroundColor: "#f6f6f7",
    borderBottom: "1px solid #d5d2d5",
    display: "flex",
    alignItems: "center",
    "& h2": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
      alignContent: "center",
    },
  },
  overWriteIcon: {
    "&:hover": {
      borderRadius: "0",
    },
  },
  headerButton: {
    minHeight: "40px",
    maxHeight: "40px",
    minWidth: "169px",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "normal",
    color: "#fff",
    textTransform: "capitalize",
  },
  personalDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    "& input": {
      padding: "8px 12px",
    },
    "& *": {
      color: theme.palette.colors.gray,
    },
  },
  dialogContent: {
    flex: "1 1 auto",
    padding: 20,
    overflowY: "auto",
    paddingBottom: 0,
  },
  emailContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  emailField: {
    width: "63%",
  },
  phoneFieldContainer: {
    width: "63%",
    "& input": {
      padding: "0 16px 0 52px !important",
    },
  },
  sendTestEmailButton: {
    height: "35px",
    marginTop: "8px",
  }
}));

export default useStyles;
